//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/TaggedObject.js";
let d=[[[0,"CommandUsed",0,0]],[[["numFeatures","features"],"GetFeatureInformation",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Weld.WeldObjectBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.WeldObjectBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.WeldObjectBuilder.FeatureInfo = class{
    constructor(feature,isNewlyCreated){
        this.feature=feature;this.isNewlyCreated=isNewlyCreated;}
    get Feature(){return this.feature}
    set Feature(val){this.feature = val}
    get Isnewlycreated(){return this.isNewlyCreated}
    set Isnewlycreated(val){this.isNewlyCreated = val}
};

SPLM.Weld.WeldObjectBuilder.CommandName = Object.freeze({
    "None" : "None", "Groove" : "Groove", "Fillet" : "Fillet", "UserDefined" : "UserDefined", "WeldPoint" : "WeldPoint", "Bead" : "Bead", "Fill" : "Fill", "ImportCsv" : "ImportCsv", "EasySpot" : "EasySpot", "DatumLocator" : "DatumLocator", "MeasurementLocator" : "MeasurementLocator", "EasyMeasurementPattern" : "EasyMeasurementPattern", "PlugSlot" : "PlugSlot", "Joint" : "Joint", "DatumSurface" : "DatumSurface", "DatumEdge" : "DatumEdge", "SurfaceWeld" : "SurfaceWeld", "Compound" : "Compound", "WeldAttribute" : "WeldAttribute", "JointDefinition" : "JointDefinition", "Jointmark" : "Jointmark", "WeldPointWizard" : "WeldPointWizard", "Transform" : "Transform", "DatumPin" : "DatumPin"});

export default SPLM;